query UsersHavePermissionQuery(
  $cloudId: ID!
  $accountIds: [String]!
  $resourceId: ID!
  $resourceType: String!
  $permission: String!
) {
  confluence_usersHavePermission(
    cloudId: $cloudId
    principalIds: $accountIds
    resourceId: $resourceId
    resourceType: $resourceType
    permission: $permission
  ) {
    usersHavePermissionList {
      principalId
      hasPermission
    }
  }
}
